// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__uKqhg","subheader":"ReorderModal_subheader__3uQg-","listWrap":"ReorderModal_listWrap__3l32D"};